import './_product-card-images.scss';

export default () => {};
